import { render, staticRenderFns } from "./QuizQuestions.vue?vue&type=template&id=ffd66e1e&lang=true&"
import script from "./QuizQuestions.vue?vue&type=script&lang=js&"
export * from "./QuizQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports